export default __webpack_public_path__ + "static/media/language.55c69dd7.svg";